export default {
    data: {
        title: 'Data',
    },
};
